export default __webpack_public_path__ + "static/home-1-b589ae5d4d8e8d458adaac15e75b0e25.png";